import React, { useState } from 'react';
import { ReconciliationList } from './ReconciliationList';
import { StatementUpload } from './StatementUpload';
import { ReconciliationWorkspace } from './ReconciliationWorkspace';
import { DiscrepancyReview } from './DiscrepancyReview';
import { ChevronLeftIcon } from 'lucide-react';
export function APStatementReconciliation({
  locale = 'en-US',
  onBack
}) {
  const [currentView, setCurrentView] = useState('list'); // list, upload, workspace, discrepancy
  const [currentReconciliation, setCurrentReconciliation] = useState(null);
  const [uploadedStatements, setUploadedStatements] = useState([]);
  // Sample data for demonstration
  const [reconciliations, setReconciliations] = useState([{
    id: 'REC-2023-001',
    vendor: 'Office Depot',
    vendorId: 'SUPP001',
    statementPeriod: 'Jan 2023',
    lastReconciled: '2023-01-31',
    status: 'Completed',
    matchedCount: 12,
    unmatchedCount: 0,
    discrepancyCount: 0
  }, {
    id: 'REC-2023-002',
    vendor: 'Dell Technologies',
    vendorId: 'SUPP002',
    statementPeriod: 'Feb 2023',
    lastReconciled: '2023-02-28',
    status: 'Needs Review',
    matchedCount: 8,
    unmatchedCount: 2,
    discrepancyCount: 3
  }, {
    id: 'REC-2023-003',
    vendor: 'PrintWorks Inc.',
    vendorId: 'SUPP003',
    statementPeriod: 'Mar 2023',
    lastReconciled: null,
    status: 'In Progress',
    matchedCount: 5,
    unmatchedCount: 7,
    discrepancyCount: 1
  }]);
  const handleStartNewReconciliation = () => {
    setCurrentView('upload');
  };
  const handleViewReconciliation = reconciliation => {
    setCurrentReconciliation(reconciliation);
    setCurrentView('workspace');
  };
  const handleUploadComplete = mappedData => {
    setUploadedStatements(mappedData);
    // Create a new reconciliation record
    const newReconciliation = {
      id: `REC-2023-00${reconciliations.length + 1}`,
      vendor: mappedData.vendor || 'Unknown Vendor',
      vendorId: mappedData.vendorId || 'UNKNOWN',
      statementPeriod: mappedData.period || 'Current Period',
      lastReconciled: null,
      status: 'In Progress',
      matchedCount: 0,
      unmatchedCount: mappedData.statements.length,
      discrepancyCount: 0
    };
    setCurrentReconciliation(newReconciliation);
    setReconciliations([...reconciliations, newReconciliation]);
    setCurrentView('workspace');
  };
  const handleBackToList = () => {
    setCurrentView('list');
    setCurrentReconciliation(null);
  };
  const handleViewDiscrepancies = () => {
    setCurrentView('discrepancy');
  };
  const handleBackToWorkspace = () => {
    setCurrentView('workspace');
  };
  return <div className="space-y-6" data-id="element-1514">
      <div className="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6" data-id="element-1515">
        <div className="mb-6 flex justify-between items-center" data-id="element-1516">
          <div data-id="element-1517">
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-1518">
              AP Statement Reconciliation
            </h2>
            <p className="mt-1 text-sm text-gray-500" data-id="element-1519">
              Upload and reconcile vendor statements with AP invoices
            </p>
          </div>
          {currentView !== 'list' && <button onClick={currentView === 'discrepancy' ? handleBackToWorkspace : handleBackToList} className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-1520">
              <ChevronLeftIcon className="h-4 w-4 mr-1" data-id="element-1521" />
              {currentView === 'discrepancy' ? 'Back to Workspace' : 'Back to List'}
            </button>}
        </div>
        {currentView === 'list' && <ReconciliationList reconciliations={reconciliations} onStartNew={handleStartNewReconciliation} onViewReconciliation={handleViewReconciliation} locale={locale} data-id="element-1522" />}
        {currentView === 'upload' && <StatementUpload onBack={handleBackToList} onUploadComplete={handleUploadComplete} locale={locale} data-id="element-1523" />}
        {currentView === 'workspace' && currentReconciliation && <ReconciliationWorkspace reconciliation={currentReconciliation} statements={uploadedStatements} onViewDiscrepancies={handleViewDiscrepancies} locale={locale} data-id="element-1524" />}
        {currentView === 'discrepancy' && currentReconciliation && <DiscrepancyReview reconciliation={currentReconciliation} statements={uploadedStatements} locale={locale} data-id="element-1525" />}
      </div>
    </div>;
}